module.exports = "<div *ngIf=\"widget && canBePreviewed\">\n  <input type=\"text\" value=\"{{ widget.previewUrl }}\" class=\"form-control\" readonly>\n  <iframe class=\"cw-widget-preview-frame\" [src]=\"widgetPreviewUrl\"></iframe>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget-detail/widget-detail-preview/widget-detail-preview.component.html
// module id = ./src/app/widgets/widget-detail/widget-detail-preview/widget-detail-preview.component.html
// module chunks = main